<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="tabs-container">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active">
            <a class="nav-link" data-toggle="tab" href="#dashboardTab"
                                @click="activeComponent = 'dashboardTab'">
              <i class="fa fa-tachometer"></i> Dashboard
            </a>
          </li>
          <li><a class="nav-link" data-toggle="tab" href="#IPsTab" @click="activeComponent = 'IPsTab'">
            <i class="fa fa-server"></i>
            IPs</a></li>
        </ul>
        <div class="tab-content">
        </div>
        <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Dashboard from './IPTabs/IPDashboard.vue'
import IPs from './IPTabs/Ips.vue'

export default {
  data () {
    return {
      activeComponent: 'dashboardTab',
      ipMockData: [
        {
          'ip': '188.241.114.106',
          'id': '29aacba3-1607-457c-8804-dc4ec9933226',
          'slots': 3,
          'used': 2,
          'freeSlots': 1,
          'data': {
            'city': 'Bucharest',
            'country': 'Romania',
            'country_code': 'RO',
            'signature': 'nginx/1.4.4'
          },
          'clients': [
            {
              '$oid': '5f91319bced39178dcb0600e'
            },
            {
              '$oid': '62664d5c40e4830f8670dafa'
            }
          ],
          'pbns': [
            {
              '$oid': '5f914c98ced39178dcb062a2'
            },
            {
              '$oid': '5f914ccdced39178dcb065ef'
            },
            {
              '$oid': '62ac52d463ec87c4b91cc937'
            }
          ]
        }
      ]
    }
  },
  components: {
    dashboardTab: Dashboard,
    IPsTab: IPs
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/IPOverview/IPContent.vue